import React from 'react';
import { ICheckboxProps } from '../../../interfaces/interfaces';

function Checkbox(props: ICheckboxProps): JSX.Element {
  const { id, label, checked, onChange, disabled } = props;

  const toggle = () => {
    if (onChange) {
      onChange(!checked);
    }
  };

  return (
    <div className="checkbox form__element form__element--checkbox">
      <input type="checkbox" className="default-input" id={id} onChange={toggle} checked={checked || false} disabled={disabled}/>
      <label htmlFor={id}>
        <p className="tx_1 no-margin-bottom">{label}</p>
      </label>
    </div>
  );
}

export default Checkbox;
